import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { Account } from './account';

const WrappedPage = withAuth(Account);
const WrappedAccountView = withLayout(LayoutType.WithOldNavOnly, WrappedPage);

export { WrappedAccountView as Account };
